import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'clear',
	theme => `
		:lang(ar) {
			transform: scaleX(-1);
		}
		width: 100%;
		margin-top: 5px;
		padding: 5px 0;
		border: 0;
		background-color: ${theme.color.text.white};
		color: ${theme.color.primary.hover};
		outline: none;
		cursor: pointer;

		&:hover {
			color: ${theme.color.primary.default};
			background-color: ${theme.color.text.F};
		}
	`
  ]
]);
